import { TruktLogo } from '../../../assets';
import { useStyles } from './SidebarLogo.styles';
import { SidebarLogoProps } from './SidebarLogo.types';

export const SidebarLogo = ({ logo, logoProps }: SidebarLogoProps) => {
  const styles = useStyles();
  return (
    <div css={styles.container}>
      {logo ? (
        <img css={styles.img} src={logo} alt="Company" />
      ) : (
        <TruktLogo aria-label="trukt" width="160" fill="white" {...logoProps} />
      )}
    </div>
  );
};
